import { render, staticRenderFns } from "./ViewObjectiveEvidences.vue?vue&type=template&id=a8ffd6b0&scoped=true&"
import script from "./ViewObjectiveEvidences.vue?vue&type=script&lang=js&"
export * from "./ViewObjectiveEvidences.vue?vue&type=script&lang=js&"
import style0 from "./ViewObjectiveEvidences.vue?vue&type=style&index=0&id=a8ffd6b0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ffd6b0",
  null
  
)

export default component.exports